import React from "react";
import "../../assets/styles/BgTechNetwork.css";

const BgTechNetwork = () => {
  return (
    <svg
      className="bg-tech-network"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 600"
      fill="none"
    >
      {/* Linhas principais */}
      <path
        d="M0 200 C200 100, 400 300, 600 200 S1000 100, 1440 250"
        stroke="#2C3E50"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M0 400 C300 500, 500 300, 800 400 S1200 500, 1440 350"
        stroke="#5A6E7F"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M200 0 C400 150, 600 50, 900 200 S1300 350, 1440 150"
        stroke="#2C3E50"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M100 500 C300 350, 700 550, 1000 450 S1400 300, 1440 500"
        stroke="#5A6E7F"
        strokeWidth="1.5"
        fill="none"
      />

      {/* Nós */}
      <circle cx="200" cy="200" r="5" fill="#FFC300" className="node" />
      <circle cx="400" cy="300" r="5" fill="#FFC300" className="node" />
      <circle cx="600" cy="200" r="5" fill="#FFC300" className="node" />
      <circle cx="800" cy="400" r="5" fill="#FFC300" className="node" />
      <circle cx="1000" cy="450" r="5" fill="#FFC300" className="node" />
      <circle cx="1200" cy="500" r="5" fill="#FFC300" className="node" />
      <circle cx="900" cy="200" r="5" fill="#FFC300" className="node" />
      <circle cx="1300" cy="350" r="5" fill="#FFC300" className="node" />
    </svg>
  );
};

export default BgTechNetwork;
